// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__nY6Zp","consentsList":"PatientConsents_consentsList__1Ymsx","consentsListEmpty":"PatientConsents_consentsListEmpty__2iJzg"};